import Vue from 'vue';

export default {
  // 获取支付信息
  getPaymentInfo(params) {
    return Vue.axios.post('/api/v1.0/chanquan/bid/getPayUrlCode', params);
  },
  // 获取VX交易结果
  getPaymentResult(transactionNo, type) {
    return Vue.axios.get('/api/v1.0/chanquan/bid/getPaymentResult/' + transactionNo + '/' + type);
  }
};
